import { Modal } from 'react-bootstrap';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';

export type IDesktopPopupProps = PropsWithChildren<{
    contentClassName?: string;
    onClose: () => void;
    size?: 'sm' | 'lg' | 'xl';
    show: boolean;
    title?: string;
}>

function DesktopPopup(props: IDesktopPopupProps) {
    const { contentClassName, children, onClose, show, size, title } = props;

    return <Modal
        backdropClassName={'desktop-popup-backdrop'}
        centered
        className={'desktop-popup'}
        onHide={onClose}
        show={show}
        size={size}
    >
        <Modal.Header closeButton>{title || ''}</Modal.Header>
        <Modal.Body className={classNames('custom-scrollbar', contentClassName)}>
            {children}
        </Modal.Body>
    </Modal>;
}

export default DesktopPopup;
